// extracted by mini-css-extract-plugin
module.exports = {"wqhni94":"wqhni94","takdomy":"takdomy","a1bczmae":"a1bczmae"};